export default __webpack_public_path__ + "static/media/palm-icon.49c9def2.svg";